import type { BlobLike } from "@pdfking/compatibility"
import type { Degree, Pixel, Rectangle } from "@pdfking/math"
import type { Sequence } from "@pdfking/tfunc"
import type { PDFReaderOptions } from "./PDFReaderOptions"

export type ColorChannel = "cyan" | "magenta" | "yellow" | "black"
export type ChannelInclination = {
  cyan: Degree
  magenta: Degree
  yellow: Degree
  black: Degree
}

export type PDFSeparationResult = {
  page: number
  channels: { channel: ColorChannel; blob: BlobLike }[]
} & Rectangle<Pixel>

export type PDFSeparationFunction = (
  input: PDFReaderOptions,
  options: {
    angle: ChannelInclination
    dpi: Pixel
    lpi: Pixel
  },
  rangeFn?: (page_count: number) => Sequence<number>
) => AsyncGenerator<PDFSeparationResult>
